module.exports = __webpack_public_path__ + "media/images/hiring-automation-5b732540024953d1d0288ce782b43857.svg";